<template>
  <v-dialog v-model="internalVisible" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline">Sign Document</v-card-title>
      <v-card-text>
        <canvas
          ref="canvas"
          class="border"
          style="width: 100%; height: 250px; background-color: white;"
        ></canvas>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" @click="clear">Clear</v-btn>
        <v-btn color="primary" @click="save">Save</v-btn>
        <v-btn color="red" @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SignaturePad from "signature_pad";

export default {
  name: "SignaturePadModal",
  props: {
    value: Boolean, // v-model compatibility
  },
  emits: ["input", "signed"],
  data() {
    return {
      pad: null,
      internalVisible: this.value,
    };
  },
  watch: {
    value(val) {
      this.internalVisible = val;
      if (val) {
        setTimeout(this.initPad, 500); // Delay to allow dialog to render properly
      }
    },
    internalVisible(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    initPad() {
      const canvas = this.$refs.canvas;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
      this.pad = new SignaturePad(canvas, {
        penColor: "black",
        backgroundColor: "white",
      });
    },
    clear() {
      if (this.pad) this.pad.clear();
    },
    save() {
      if (this.pad.isEmpty()) {
        this.$emit("input", false);
        alert("Please sign before saving.");
        return;
      }
      const signature = this.pad.toDataURL("image/png");
      this.$emit("signed", signature);
      this.$emit("input", false);
    },
    close() {
      this.$emit("input", false);
    },
  },
};
</script>
<style scoped>
canvas {
  cursor: pointer;
  border: 2px solid black;
}
canvas:active {
  cursor: pointer;
}
</style>